import { gql } from '@apollo/client';
import { PAYMENT_METHOD_FRAGMENT } from '~/services/fetch-existing-payment-methods/fetch-existing-payment-method.queries';

export const LISTEN_FOR_PAYMENT = gql`
  subscription Flex_ListenForPayment($accountId: Int!) {
    paymentMethodCreated(accountId: $accountId) {
      ...PaymentMethodData
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
